import React from 'react';

/**
 * 팁 & 트릭 섹션 컴포넌트
 */
function TipsSection() {
  return (
    <section id="tips" className="guide-section">
      <h2>💡 팁 & 트릭</h2>
      
      <div className="feature-grid">
        <div className="feature-card">
          <h3>⌨️ 키보드 단축키</h3>
          <div className="feature-steps">
            <p><strong>기본 단축키:</strong></p>
            <ul>
              <li><code>Ctrl + N</code> - 새 패스워드 추가</li>
              <li><code>Ctrl + F</code> - 검색창 포커스</li>
              <li><code>Escape</code> - 모달 닫기</li>
              <li><code>Enter</code> - 폼 제출</li>
            </ul>
            
            <p><strong>태그 관련:</strong></p>
            <ul>
              <li><code>Enter</code> - 태그 추가</li>
              <li><code>Backspace</code> - 마지막 태그 제거</li>
              <li><code>Tab</code> - 다음 필드로 이동</li>
            </ul>
          </div>
        </div>

        <div className="feature-card">
          <h3>🔒 보안 모범 사례</h3>
          <div className="feature-steps">
            <p><strong>패스워드 생성:</strong></p>
            <ul>
              <li>📏 최소 12자 이상 사용</li>
              <li>🔤 대소문자, 숫자, 특수문자 조합</li>
              <li>❌ 개인정보 사용 금지</li>
              <li>🎲 패스워드 생성기 적극 활용</li>
            </ul>
            
            <p><strong>관리 습관:</strong></p>
            <ul>
              <li>🔄 3개월마다 중요 패스워드 변경</li>
              <li>❌ 패스워드 재사용 절대 금지</li>
              <li>📱 2FA 반드시 활성화</li>
              <li>💾 정기적인 데이터 백업</li>
            </ul>
          </div>
        </div>

        <div className="feature-card">
          <h3>🚀 효율적인 사용법</h3>
          <div className="feature-steps">
            <p><strong>조직화 팁:</strong></p>
            <ul>
              <li>🏷️ 태그를 활용한 체계적 분류</li>
              <li>📝 명확한 제목 규칙 정하기</li>
              <li>🔍 검색 필터 조합 활용</li>
              <li>⭐ 자주 사용하는 패스워드에 중요 태그</li>
            </ul>
            
            <p><strong>시간 절약:</strong></p>
            <ul>
              <li>📋 빠른 복사 버튼 활용</li>
              <li>🎲 패스워드 생성기로 즉시 생성</li>
              <li>🔍 키워드 검색으로 빠른 찾기</li>
              <li>⌨️ 키보드 단축키 숙지</li>
            </ul>
          </div>
        </div>

        <div className="feature-card">
          <h3>🛠️ 문제 해결 팁</h3>
          <div className="feature-steps">
            <p><strong>로그인 문제:</strong></p>
            <ul>
              <li>🌐 브라우저 쿠키/캐시 정리</li>
              <li>📱 모바일에서는 기본 브라우저 사용</li>
              <li>🔒 팝업 차단 해제</li>
              <li>🔄 페이지 새로고침 후 재시도</li>
            </ul>
            
            <p><strong>성능 최적화:</strong></p>
            <ul>
              <li>💾 정기적인 브라우저 캐시 정리</li>
              <li>🔍 검색 시 구체적인 키워드 사용</li>
              <li>📄 많은 패스워드 시 태그로 분류</li>
              <li>🗑️ 사용하지 않는 패스워드 정리</li>
            </ul>
          </div>
        </div>
      </div>
      
      {/* 마무리 메시지 */}
      <div className="continue-reading">
        <p>
          🎉 축하합니다! PW-Wallet의 모든 기능을 마스터했습니다.<br/>
          이제 안전하고 효율적인 패스워드 관리를 시작해보세요!
        </p>
      </div>
    </section>
  );
}

export default TipsSection;